import React from 'react'
import CurrencyFormat, { StrictProps } from 'react-currency-format'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: block;
`
export type TCurrencyInputNew = Omit<
  StrictProps,
  | 'displayType'
  | 'className'
  | 'thousandSeparator'
  | 'decimalSeparator'
  | 'format'
>

const CurrencyInputNew = (props: TCurrencyInputNew): React.ReactElement => {
  return (
    <Wrapper>
      <CurrencyFormat
        {...props}
        value={props.value as any}
        displayType="input"
        className="form-control"
        thousandSeparator="."
        decimalSeparator=","
      />
    </Wrapper>
  )
}

export default CurrencyInputNew
